import { FC } from 'react'
import RadioButton from './radioButton'
import { CustomerGender } from '@/network/graphql.g'

type GenderRadioBoxProps = {
  value: CustomerGender
  onChanged: (gender: CustomerGender) => void
  isChecked: boolean
  title: string
} & Rest

const GenderRadioBox: FC<GenderRadioBoxProps> = ({
  value,
  onChanged,
  isSelected,
  title,
  ...rest
}) => {
  return (
    <RadioButton
      title={title}
      name={'male'}
      onChanged={onChanged}
      value={value}
      isChecked={isSelected}
      {...rest}
    />
  )
}

export default GenderRadioBox
